import React from 'react';
import { CookieSettings } from './../CookieSettings';
import { CookieMessage } from './../CookieMessage';

import * as Types from './../../types';
import { ACTIVE_TAB_POPUP } from './../../constants';

import style from './ContentRenderer.scss';

export const ContentRenderer: React.FC<Types.IContentRendererProps> = (props) => {
    const { activeTab, ...rest } = props;
    const renderComponent = [
        { tab: ACTIVE_TAB_POPUP.MESSAGE, component: <CookieMessage/> },
        { tab: ACTIVE_TAB_POPUP.SETTING, component: <CookieSettings {...rest} /> }
    ];

    return (
        <>
            {renderComponent.map(({ tab, component }) => (
                <div key={tab} className={activeTab === tab ? style.componentShow : style.componentHide}>
                    {component}
                </div>
            ))}
        </>
    );
};

